import { RootState } from "./types";

export default {
    reload(state: RootState) {
        return state.reload;
    }
};
